<div class="card-container coming-soon_component">
    <div class="text-center">
        <mat-icon svgIcon="dmc"></mat-icon>
        <p class="text" translate>comingSoon.teaser</p>
    </div>
</div>
